import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_COMPANIES_API,
    GET_COMPANIES_OPTIONS_API,
    POST_COMPANIES_OVERVIEW_API,
    GET_COMPANIES_COMPANYID_API,
    POST_COMPANIES_API,
    PUT_COMPANIES_COMPANYID_API,
} from '@Apis/apiPath';

/** 公司相關 API(對應後端 CV.Company) */
const useCompanyApi = () => {
    const Axios = useAxios();

    /** 舊端點保留(全量、無分頁)，前端公司管理頁不再使用，改用 postCompaniesOverviewApi */
    const getCompaniesApi = useCallback(
        async () => {
            return await Axios.get(GET_COMPANIES_API);
        },
        // eslint-disable-next-line
        [],
    );

    /**
     * 取得公司相關下拉式選單
     * @returns {Promise<{companyOptions: Array}>}
     */
    const getCompanyOptionsApi = useCallback(
        async () => {
            return await Axios.get(GET_COMPANIES_OPTIONS_API);
        },
        // eslint-disable-next-line
        [],
    );

    /** 公司總覽(伺服器端搜尋與分頁) */
    const postCompaniesOverviewApi = useCallback(
        async (params) => {
            return await Axios.post(POST_COMPANIES_OVERVIEW_API, params);
        },
        // eslint-disable-next-line
        [],
    );

    const getCompanyApi = useCallback(
        async (companyID) => {
            return await Axios.get(GET_COMPANIES_COMPANYID_API(companyID));
        },
        // eslint-disable-next-line
        [],
    );

    const postCompanyApi = useCallback(
        async (params) => {
            return await Axios.post(POST_COMPANIES_API, params);
        },
        // eslint-disable-next-line
        [],
    );

    const putCompanyApi = useCallback(
        async (companyID, params) => {
            return await Axios.put(PUT_COMPANIES_COMPANYID_API(companyID), params);
        },
        // eslint-disable-next-line
        [],
    );

    return {
        getCompaniesApi,
        getCompanyOptionsApi,
        postCompaniesOverviewApi,
        getCompanyApi,
        postCompanyApi,
        putCompanyApi,
    };
};

export default useCompanyApi;
